import React from 'react';
import { useLoadingDotsStyles } from './styles';
import Box from '@material-ui/core/Box';

const LoadingDots = () => {
	const classes = useLoadingDotsStyles();

	return (
		<Box className={classes.loadingDots}>
			<Box className={classes.dot}></Box>
			<Box className={classes.dot}></Box>
			<Box className={classes.dot}></Box>
		</Box>
	);
};

export default LoadingDots;
